import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatErr } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("caseirinho_token");
        if (!token) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("caseirinho_token");
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    async function login(email, password) {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("caseirinho_token", data.token);
            setUser(data.user);
            return { ok: true, user: data.user };
        } catch (e) {
            return { ok: false, error: formatErr(e.response?.data?.detail) };
        }
    }

    async function register(payload) {
        try {
            const { data } = await api.post("/auth/register", payload);
            localStorage.setItem("caseirinho_token", data.token);
            setUser(data.user);
            return { ok: true, user: data.user };
        } catch (e) {
            return { ok: false, error: formatErr(e.response?.data?.detail) };
        }
    }

    async function logout() {
        try {
            await api.post("/auth/logout");
        } catch (err) {
            // Logout falhar no servidor não é bloqueante — limpamos sempre o estado local
            console.warn("Logout request failed (cleared local state):", err?.message);
        }
        localStorage.removeItem("caseirinho_token");
        setUser(null);
    }

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
